import { AnimatedButton } from '@dtx-company/shared-components/src/components/atoms/AnimatedButton/index'
import { AnimatedButtonProps } from '@dtx-company/shared-components/src'
import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FileTypeSelect } from './FileTypeSelect'
import { useDownloadButtonLabels } from './SimplifiedDesktop.hooks'
import React from 'react'

type DownloadButtonsProps = Pick<AnimatedButtonProps, 'onClick' | 'loading' | 'disabled'> & {
  emailIsSSOEnabled: boolean
}

export const DownloadButtons = ({
  disabled,
  emailIsSSOEnabled,
  loading,
  onClick
}: DownloadButtonsProps): JSX.Element => {
  const { buttonLabel, loadingLabel } = useDownloadButtonLabels(emailIsSSOEnabled)

  return (
    <Box position="relative" width="100%" minWidth={0}>
      <AnimatedButton
        type="submit"
        height="44px"
        width="100%"
        fontWeight={600}
        padding="0 10px"
        borderRadius={'4px 0 0 4px'}
        loading={loading}
        onClick={onClick}
        disabled={disabled}
        data-heap-id="DownloadButton"
        loadingProps={{
          label: loadingLabel
        }}
        label={buttonLabel}
      />
      <FileTypeSelect />
    </Box>
  )
}
